<app-screen-shell
  [contentClass]="'container player-profile-page footballer-friends-page'"
  titleKey="players.footballerFriends"
  [loading]="isContentLoading()"
  loadingTitleKey="players.footballerFriendsLoading"
  [hideContentWhileLoading]="true"
  (back)="goBack()">

  @if (!isContentLoading() && (!loading || friends.length > 0)) {
  <section class="footballer-friends-toolbar profile-content-width player-detail-content-width">
    <label class="sr-only" for="footballerFriendsSearch">{{ 'players.searchFriends' | translate }}</label>
    <div class="footballer-friends-search">
      <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
      <input
        id="footballerFriendsSearch"
        type="search"
        [value]="searchQuery"
        [placeholder]="'players.searchFriends' | translate"
        (input)="onSearch($any($event.target).value)">
      @if (searchQuery) {
        <button type="button" (click)="clearSearch()" [title]="'common.clear' | translate" [attr.aria-label]="'common.clear' | translate">
          <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="footballer-friends-total">
      <span>{{ total }}</span>
      <strong>{{ 'players.footballerFriendsTotal' | translate }}</strong>
      <div class="footballer-friends-sort" [attr.aria-label]="'players.footballerFriendsSort' | translate">
        <button
          type="button"
          [class.is-active]="sortBy === 'matchesTogether'"
          [class.is-ascending]="sortBy === 'matchesTogether' && sortDirection === 'asc'"
          [disabled]="loading"
          (click)="setSort('matchesTogether')"
          [title]="sortTitle('matchesTogether')"
          [attr.aria-label]="sortTitle('matchesTogether')">
          <i [class]="'match.inviteFriends' | nogoshIcon" aria-hidden="true"></i>
          <i [class]="'common.chevronDown' | nogoshIcon" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          [class.is-active]="sortBy === 'winRate'"
          [class.is-ascending]="sortBy === 'winRate' && sortDirection === 'asc'"
          [disabled]="loading"
          (click)="setSort('winRate')"
          [title]="sortTitle('winRate')"
          [attr.aria-label]="sortTitle('winRate')">
          <i [class]="'match.stats' | nogoshIcon" aria-hidden="true"></i>
          <i [class]="'common.chevronDown' | nogoshIcon" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </section>
  }

  @if (!isContentLoading() && errorMsg) {
    <section class="public-player-profile-state">
      <i [class]="'player.team' | nogoshIcon" aria-hidden="true"></i>
      <h1>{{ 'common.error' | translate }}</h1>
      <p>{{ errorMsg }}</p>
    </section>
  }

  @if (!isContentLoading() && !errorMsg && friends.length > 0) {
    <section class="footballer-friends-list profile-content-width player-detail-content-width" [attr.aria-label]="'players.footballerFriends' | translate">
      @for (friend of friends; track friend.playerId) {
        <article class="footballer-friend-card">
          <button type="button" class="footballer-friend-main" (click)="openMatchHistory(friend)">
            <span class="footballer-friend-avatar">
              @if (friend.avatar) {
                <img [src]="friend.avatar" [alt]="displayName(friend)" onerror="this.style.display='none'">
              } @else {
                <span>{{ initials(friend) }}</span>
              }
            </span>
            <span class="footballer-friend-copy">
              <strong>{{ displayName(friend) }}</strong>
              @if (friend.city) {
                <span>{{ friend.city }}</span>
              }
            </span>
            <i [class]="'match.history' | nogoshIcon" aria-hidden="true"></i>
          </button>

          <div class="footballer-friend-stats">
            <div>
              <span>{{ 'players.sharedMatches' | translate }}</span>
              <strong>{{ friend.sharedMatchCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'players.sameTeamRounds' | translate }}</span>
              <strong>{{ friend.sameTeamRoundCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'players.lastSharedMatch' | translate }}</span>
              <strong>{{ lastSharedMatchLabel(friend) }}</strong>
            </div>
            <div>
              <span>{{ 'players.togetherRecord' | translate }}</span>
              <strong>{{ friend.togetherWins || 0 }}W {{ friend.togetherDraws || 0 }}D {{ friend.togetherLosses || 0 }}L</strong>
            </div>
            <div>
              <span>{{ 'players.togetherWinRate' | translate }}</span>
              <strong>{{ winRate(friend) }}%</strong>
            </div>
          </div>
        </article>
      }
    </section>
  }

  @if (!isContentLoading() && !loading && !errorMsg && friends.length === 0) {
    <section class="public-player-profile-state">
      <i [class]="'player.team' | nogoshIcon" aria-hidden="true"></i>
      <h1>{{ 'players.footballerFriendsEmptyTitle' | translate }}</h1>
      <p>{{ searchQuery ? ('players.footballerFriendsSearchEmpty' | translate) : ('players.footballerFriendsEmpty' | translate) }}</p>
    </section>
  }

  @if (!isContentLoading() && !errorMsg && hasMore) {
    <div class="event-history-load-more">
      <button type="button" class="btn btn-secondary btn-sm px-3 text-white" [disabled]="loading" (click)="loadMore()">{{ 'common.more' | translate }}</button>
    </div>
  }
</app-screen-shell>
